module.exports = __webpack_public_path__ + "fonts/ai-squaber-yellow.svg";